import { render, staticRenderFns } from "./InsuranceCompanyUpdate.vue?vue&type=template&id=77e5d532&"
import script from "./InsuranceCompanyUpdate.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompanyUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports